import { useEffect, useState } from "react";
import { createClient } from "pexels";

const client_id: any = process.env.REACT_APP_PEXELS_CLIENT_ID
const client = createClient(client_id);

export const usePixabaySearch = () => {
  const [query, setQuery] = useState({q:"",index:0});
  const [loading, setLoading] = useState(false);
  const [photos, setPhotos] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [loadmore,setLoadMore] = useState(true);
  const [dLength,setDlength] = useState(0);
  
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);

    const fetchPhoto = async() => {
      const per_page = 26

      if(query.q === ''){
      const data: any = await client.photos.search({query: 'popular', per_page, page})
      setPhotos(data.photos)
      setDlength(data.photos.length|| 0);
      }else{
      const data: any = await client.photos.search({query: query.q, per_page, page,})
      setPhotos(data.photos)
      setDlength(data.photos.length|| 0);
      }
    }

    fetchPhoto()
    return () => {
      controller.abort();
    };
  }, [query]);

  const search = (query: any) => {
    setQuery({q:query.q, index:query.index});
  };

  const fetchMoreData = async() => {

    if(query.q === ''){
    const data: any = await client.photos.search({query: 'popular', page : page + 1, per_page: 10})
    const d = photos
    setPhotos([...d, ...data.photos])
    setPage(page + 1)
    }else{
    const data: any = await client.photos.search({query: query.q, page : page + 1, per_page: 10})
    const d = photos
    setPhotos([...d, ...data.photos])
    setPage(page + 1) 
    }
  }

  return { search, photos, loading, fetchMoreData,loadmore,setLoadMore,setPage };
};